(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeServiceDialogController', TypeServiceDialogController);

    TypeServiceDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeService'];

    function TypeServiceDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeService) {
        var vm = this;
        vm.typeService = entity;
        vm.load = function(id) {
            TypeService.get({id : id}, function(result) {
                vm.typeService = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeService.id !== null) {
                TypeService.update(vm.typeService, onSaveSuccess, onSaveError);
            } else {
                TypeService.save(vm.typeService, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
